/**
 * Utility function to get the appropriate logo based on the current subdomain
 * @returns The path to the logo image based on the subdomain
 */
/**
 * Alternative approach using direct imports for better tree shaking
 * This is more efficient than using require()
 */
import homepageLogo from '../assets/images/home/homepage.png';
import langerbergLogo from '../assets/images/home/langerberg.png';
import victorKhanyeLogo from '../assets/images/home/victorKhanye.png';
import ephraimLogo from '../assets/images/home/ephraim.png';

export const getLogoBySubdomain = (): string => {
  // Get the current hostname
  const hostname = window.location.hostname;

  // Extract subdomain from hostname
  const parts = hostname.split('.');
  const subdomain = parts.length > 2 ? parts[0].toLowerCase() : '';

  // Return the appropriate logo based on subdomain
  switch (subdomain) {
    case 'langeberg':
      return require('../assets/images/home/langerberg.png');
    case 'demo':
      return require('../assets/images/home/homepage.png');
    case 'victorkhanye':
      return require('../assets/images/home/victorKhanye.png');
    case 'ephraim':
      return require('../assets/images/home/ephraim.png');
    default:
      // Default to victorKhanye logo if no matching subdomain
      return require('../assets/images/home/victorKhanye.png');
  }
};

export const getLogoBySubdomainOptimized = (): string => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  const subdomain = parts.length > 2 ? parts[0].toLowerCase() : '';

  switch (subdomain) {
    case 'langeberg':
      return langerbergLogo;
    case 'demo':
      return homepageLogo;
    case 'victorkhanye':
      return victorKhanyeLogo;
    case 'ephraim':
      return ephraimLogo;
    default:
      return victorKhanyeLogo;
  }
};
